/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ITechnologyAreaModelData } from "Interfaces/SiteContent/ITechnologyAreaModelData";

import {
  TECHAREADATA_LOAD,
  TECHAREADATA_LOAD_FAILURE,
  TECHAREADATA_LOAD_SUCCESS,
} from "./TechnologyAreaTypes";

/**
 *@interface
 */
export interface IGetTechnologyAreas {
  type: typeof TECHAREADATA_LOAD;
  tenant: string;
}

/**
 *@interface
 */
export interface IGetTechnologyAreaSuccess {
  type: typeof TECHAREADATA_LOAD_SUCCESS;
  technologyAreaOptionList: ITechnologyAreaModelData[];
}

/**
 * @interface
 */
export interface IGetTechnologyAreaFailure {
  type: typeof TECHAREADATA_LOAD_FAILURE;
  technologyAreaLoadError: string;
}

/**
 *@function Function to get technology areas
 @param {string} tenant Name of the tenant
 @returns { TechnologyAreaActionTypes }
 */
export const getTechnologyAreas = (tenant: string): TechnologyAreaActionTypes => ({
  type: TECHAREADATA_LOAD,
  tenant: tenant,
});

/**
 *
 * @param applicationFormTechnologyFocusArea
 */
export const getTechnologyAreaSuccess = (
  technologyAreaOptionList: ITechnologyAreaModelData[]
): TechnologyAreaActionTypes => ({
  type: TECHAREADATA_LOAD_SUCCESS,
  technologyAreaOptionList,
});

/**
 *
 * @param errorMessage
 */
export const getTechnologyAreaFailure = (
  technologyAreaLoadError: string
): TechnologyAreaActionTypes => ({
  type: TECHAREADATA_LOAD_FAILURE,
  technologyAreaLoadError,
});

export type TechnologyAreaActionTypes =
  | IGetTechnologyAreas
  | IGetTechnologyAreaSuccess
  | IGetTechnologyAreaFailure;
